import * as React from 'react';
export const myobSvg = React.forwardRef(function myobSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#54267C',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M26.791 12.924h-.096v.195h.099c.103 0 .151-.025.151-.095 0-.072-.049-.1-.154-.1Zm-3.128 3.54v.852s1 .166 1.018-.426c.019-.594-1.018-.426-1.018-.426Zm-4.559-1.686s-.866-.075-.89 1.354c-.022 1.333.88 1.236.88 1.236s.815.097.827-1.279c.01-1.376-.817-1.31-.817-1.31m5.468.464c.02-.592-.944-.425-.944-.425v.85s.926.168.944-.425Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M27.143 13.495a.49.49 0 1 1-.344-.835c.13 0 .254.052.346.144.091.093.14.216.14.348a.465.465 0 0 1-.142.343Zm-1.774 4.506c-1.037.48-3.332.203-3.332.203v-4.256s3.645-.37 4.034.703c.171.472.04.786-.158.99-.07.074-.151.133-.23.18a1.43 1.43 0 0 1-.389.162s.264.089.313.114c.11.052.212.12.301.204a.904.904 0 0 1 .163.2c.24.407.333 1.018-.702 1.5Zm-6.183.313h-.02c-1.889.13-3.106-1.443-2.551-2.998.555-1.554 2.551-1.46 2.551-1.46h.02s1.753-.075 2.27 1.387c.516 1.452-.58 3.071-2.27 3.071Zm-3.984-.062h-1.673v-1.627l-1.52-2.684h1.816l.885 1.68.882-1.68h1.251l-1.634 2.72-.007 1.591Zm-3.93 0h-.946l-.18-3.219-.725 3.22H7.8l-.5-3.09-.387 3.09h-1.16l.413-4.312h2.496l.255 2.775.598-2.775h2.163l.34 4.311h-.746Zm-3.086-6.251c-2.328 0-4.152 1.734-4.152 3.872v4.313h19.779c2.139 0 4.133-1.59 4.133-3.873v-4.312H8.186Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M27.037 13.423h-.105l-.118-.244h-.119v.244h-.093v-.56h.208c.154 0 .233.048.233.154 0 .077-.05.135-.133.15l.127.256Zm-.242-.704a.43.43 0 1 0-.002.862.433.433 0 0 0 .17-.83.429.429 0 0 0-.168-.032Z',
      fill: '#fff',
    }),
  );
});
myobSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var myob = {
  category: 'brand',
  colorable: false,
  name: 'myob',
  svg: myobSvg,
};
